// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"76398151003d84d6b272","293":"9e933abb1b6aac03485b"}[chunkId] + ".js";
};